import { render, staticRenderFns } from "./Forma4.vue?vue&type=template&id=0ff9a201&scoped=true"
import script from "./Forma4.vue?vue&type=script&lang=js"
export * from "./Forma4.vue?vue&type=script&lang=js"
import style0 from "./Forma4.vue?vue&type=style&index=0&id=0ff9a201&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff9a201",
  null
  
)

export default component.exports